import { State } from 'model/State';
import { fetchWithParamValidation } from 'util/fetchWithParamValidation';
import { getFromHamsClient } from '../../../../util/mac/api/marketplace/get';

export const getVendorDetailsByProductKey = async (key: string, state: State) =>
  fetchWithParamValidation(({ productKey }) => getFromHamsClient(`/terms/${productKey}`, state), {
    productKey: key,
  });
